import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';

export interface ActiveFilterChip {
  id: number;
  categoryDisplay: string; // Ej: "Fase Juego"
  valueDisplay: string;    // Ej: "Posicional"
}

@Component({
  selector: 'app-active-filters-display',
  templateUrl: './active-filters-display.component.html',
  styleUrls: ['./active-filters-display.component.scss'],
  standalone: true,
  imports: [CommonModule, MatChipsModule, MatIconModule],
})
export class ActiveFiltersDisplayComponent {

  @Input() activeFilters: ActiveFilterChip[] = [];

  // Emite el ID numérico del filtro que el usuario quiere eliminar
  @Output() removeFilterId = new EventEmitter<number>();

  /**
   * Método llamado cuando el usuario hace clic en la 'x' de un chip.
   * Emite el ID del filtro para que el componente padre lo gestione.
   * @param idToRemove El ID numérico del PlayDefinition a eliminar.
   * @param event El evento del mouse para detener la propagación si es necesario.
   */
  removeFilter(idToRemove: number, event?: MouseEvent): void {
    if (event) {
      event.stopPropagation();
    }
    this.removeFilterId.emit(idToRemove);
  }
}
